import { KeyboardArrowRight } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import SmallStoreCard from "features/searchStore/components/SmallStoreCard";

export function RelatedStoreSection() {
  return (
    <Box width="100%" display="flex" justifyContent="center">
      <Box display="flex" flexDirection="column" width="1000px">
        <Typography variant="h5" fontWeight="bold" sx={{ my: 2 }}>
          こちらとよく一緒に閲覧されているレストラン
        </Typography>

        <Box display="flex" justifyContent="space-between" my={1}>
          <SmallStoreCard
            imgPath="/images/store-detail/store1.avif"
            name="オリエンタルラウンジ／マンダリン オリエンタル 東京"
            area="日本橋"
            point={4.54}
          />

          <SmallStoreCard
            imgPath="/images/store-detail/store2.avif"
            name="WASHOKU 蒼天 SOUTEN／ザ・プリンスギャラリー 東京紀尾井町，ラグジュアリーコレクションホテル"
            area="赤坂見附・永田町"
            point={4.33}
          />

          <SmallStoreCard
            imgPath="/images/store-detail/store3.avif"
            name="All-Day Dining OASIS GARDEN／ザ・プリンスギャラリー 東京紀尾井町，ラグジュアリーコレクションホテル"
            area="赤坂見附・永田町"
            point={4.28}
          />

          <SmallStoreCard
            imgPath="/images/store-detail/store4.avif"
            name="Peter／ザ・ペニンシュラ東京"
            area="日比谷"
            point={4.33}
          />

          <SmallStoreCard
            imgPath="/images/store-detail/store5.avif"
            name="つきじ治作"
            area="築地"
            point={4.62}
          />
        </Box>

        <Box p={1} my={2} display="flex" flexDirection="column" alignItems='center'>
          <Typography variant="h5" sx={{my: 2}}>ご希望のレストランが見つかりませんか？</Typography>
          <Button sx={{py: 2, px: 5}} variant="outlined" endIcon={<KeyboardArrowRight />}>
            <Typography variant="h6">周辺のレストランを探す</Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
